import type { MediaRef } from "@velizhanin-dev/bot-scenario"
import { getScenarioMediaUrl, presignScenarioMedia } from "../api/media"
import type { MediaKind } from "../api/types"

/** Куда загружать файл и откуда брать превью: медиа сценария или рассылки бота. */
export interface MediaSource {
	cacheKey: readonly unknown[]
	presign: (body: {
		kind: MediaKind
		fileName: string
		mime: string
		size: number
	}) => Promise<{ uploadUrl: string; media: MediaRef }>
	previewUrl: (s3Key: string) => Promise<{ url: string }>
}

export const scenarioMediaSource = (scenarioId: string): MediaSource => ({
	cacheKey: ["bot-builder", "media-url", scenarioId],
	presign: (body) => presignScenarioMedia(scenarioId, body),
	previewUrl: (s3Key) => getScenarioMediaUrl(scenarioId, s3Key),
})
